import { z } from "zod";
import {
  createPersonDtoSchema,
  personDtoSchema,
  personFromDto,
  PersonSchema,
  personToDto,
} from "./person";
import { apiListSchema } from "./list";

//? DTO
export const CreateProviderDtoSchema = z.object({
  PaymentAfterInvoice: z.boolean().nullish(),
  Person: createPersonDtoSchema,
});
export type CreateProviderDto = z.infer<typeof CreateProviderDtoSchema>;

export const ProviderDtoSchema = CreateProviderDtoSchema.extend({
  Id: z.number(),
  PersonId: z.number(),
  Person: personDtoSchema,
});
export type ProviderDto = z.infer<typeof ProviderDtoSchema>;

export const providerDtoListSchema = apiListSchema(ProviderDtoSchema);

//? Model

export const CreateProviderSchema = PersonSchema.extend({
  paymentAfterInvoice: z.boolean().nullish(),
  personId: z.string(),
});
export type CreateProvider = z.infer<typeof CreateProviderSchema>;

export const ProviderSchema = CreateProviderSchema.extend({
  id: z.string().min(1),
});

export type Provider = z.infer<typeof ProviderSchema>;

//? Mappers

export function mapCreateProviderToDto(
  service: CreateProvider
): CreateProviderDto {
  return {
    PaymentAfterInvoice: service.paymentAfterInvoice,
    Person: personToDto(service),
  };
}

export function mapProviderFromDto(dto: ProviderDto): Provider {
  return {
    id: dto.Id.toString(),
    personId: dto.PersonId.toString(),
    paymentAfterInvoice: dto.PaymentAfterInvoice,
    ...personFromDto(dto.Person),
  };
}

export function mapProviderToDto(dto: Provider): ProviderDto {
  return {
    Id: Number.parseInt(dto.id),
    PaymentAfterInvoice: dto.paymentAfterInvoice,
    PersonId: Number.parseInt(dto.personId ?? ""),
    Person: {
      Id: Number.parseInt(dto.personId ?? ""),
      ...personToDto(dto),
    },
  };
}
